import { useContext } from 'react';
import Context from './Context';
export { default as withShop } from './with';
export { default } from './Provider';

export function useShop() {
  return useContext(Context);
}
